/* 
Dependencies
*/
import * as Service from "../../Service/CallCenter.Service";
import { toasterModel, toasterColor } from "../../Models/ToasterModel";
import { mapGetters } from "vuex";
import { TheMask } from "vue-the-mask";

export default {
  name: "CallLogEntry",

  components: { TheMask },

  data: () => ({
    LogDetails: {},
    categories: [],
    subCategories: [],
    rules: {
      fnameRules: [
        v => !!v || "First name is required",
        v =>
          (v && v.length <= 15) || "First Name must be less than 15 characters"
      ],
      required: [v => !!v || "This field is required"],
      phoneNumber: [
        // v => !!v || "This field is required",
        val => (val || "").length == 10 || "Number must be 10 digits"
      ]
    }
  }),

  props: {
    logDetailsProp: {
      type: Object,
      default: () => {
        return {
          Ctrl: 0,
          Idate: new Date().toLocaleString().replace(",", ""),
          EmpNo: "",
          Email: "",
          CustomerName: "",
          PhoneNumber: "",
          CategoryId: 0,
          SubCategoryId: 0,
          Remarks: ""
        };
      }
    },
    Categories: {
      type: Array
    },
    isEdit: {
      type: Boolean
    }
  },

  mounted() {
    this.setLogDetails();
    // console.log(this.getUserDetails);
  },

  computed: {
    GetCategories() {
      let tempList = [];
      this.Categories.forEach(Category => {
        let catago = {
          id: Category.CategoryId,
          text: Category.CategoryText
        };
        tempList.push(catago);
      });
      this.categories = tempList;
      return this.categories;
    },
    GetSubCategories() {
      //Object.keys(this.LogDetails).length == 0 ||
      if (this.LogDetails.CategoryId == 0) {
        return;
      } else {
        this.subCategories = this.Categories.filter(
          x => x.CategoryId == this.LogDetails.CategoryId
        )[0].SubCategories;

        return this.subCategories;
      }
    },
    ...mapGetters(["getUserDetails"])
  },

  methods: {
    setLogDetails() {
      this.LogDetails = this.logDetailsProp;
      this.LogDetails.EmpNo = this.getUserDetails.id;
      this.LogDetails.Email = this.getUserDetails.email;
    },
    async LogDetailsEntry() {
      if (this.$refs.form.validate()) {
        var result = {};
        if (this.isEdit) {
          result = await Service.UpdateAgentCallDetails(this.LogDetails);
          if (result.error) {
            this.$store.commit(
              "toaster",
              toasterModel("Call details updated Failed", toasterColor.info)
            );
            this.$router.app.$emit("RefreshCallDetails");
            return;
          }
          this.$store.commit(
            "toaster",
            toasterModel(
              "Call details updated successfully",
              toasterColor.success
            )
          );
        } else {
          result = await Service.InsertUpdateCallLog(this.LogDetails);
          if (result.error) {
            this.$store.commit(
              "toaster",
              toasterModel("Call details insertion failed", toasterColor.info)
            );
            return;
          }
          this.$refs.form.reset();
          this.$store.commit(
            "toaster",
            toasterModel(
              "Call details inserted successfully",
              toasterColor.success
            )
          );
        }
        this.$router.app.$emit("RefreshCallDetails");
      }
    }
  },

  watch: {
    logDetailsProp(newValue, oldValue) {
      this.LogDetails = newValue;
    }
  }
};
